import { IonItem, IonLabel, IonSelect, IonSelectOption } from '@ionic/react'
import { dequal } from 'dequal/lite'

import { useUpdateAdminClient } from '../../hooks/clients/mutations'
import { useAdminAssociates } from '../../hooks/queries/use-associate'

import type { AdvancedClientDetail } from '../clients.schema'

function AssociateSelect({ client }: { client: AdvancedClientDetail }) {
  const selectedAssociates = client.users?.map((u) => u.objectId) ?? []

  const associatesQuery = useAdminAssociates()
  const updateClient = useUpdateAdminClient()

  function handleSelect(selectedUsers: Array<string>) {
    // BUG: incorrectly formatted values - https://github.com/ionic-team/ionic-framework/issues/24584
    if (!Array.isArray(selectedUsers)) return

    const currentUsers = client.users
      ? client.users.map((client) => client.objectId)
      : []

    // do nothing if value (selected users) is same as client.users (current state)
    if (dequal(selectedUsers, currentUsers)) {
      return false
    }

    updateClient.mutate({
      objectId: client.objectId,
      users: selectedUsers,
    })
  }

  return (
    <IonItem color="secondary" lines="none">
      <IonLabel>Assigned to:</IonLabel>
      <IonSelect
        multiple
        value={selectedAssociates}
        onIonChange={(e) => {
          handleSelect(e.detail.value)
        }}
        onClick={(e) => {
          e.stopPropagation()
          e.preventDefault()
        }}
      >
        {associatesQuery.data?.map((associate) => (
          <IonSelectOption key={associate.objectId} value={associate.objectId}>
            {associate.name || '-'}
          </IonSelectOption>
        ))}
      </IonSelect>
    </IonItem>
  )
}

export { AssociateSelect }
